import { brandInfo } from '@/mocks/anime';

export default function Reputation() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14 bg-background-100/50">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
          <i className="ri-chat-heart-line text-accent-400 mr-2"></i>用户口碑
        </h2>
        <p className="text-sm text-foreground-400 mt-2">听听我们的用户怎么说</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        {brandInfo.testimonials.map((testimonial) => (
          <div
            key={testimonial.name}
            className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/50"
          >
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`text-sm ${i < testimonial.rating ? 'ri-star-fill text-secondary-400' : 'ri-star-line text-foreground-600'}`}
                ></i>
              ))}
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              ❝ {testimonial.content} ❞
            </p>
            <p className="text-xs text-foreground-500 font-medium">
              —— {testimonial.name}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}